import React from 'react';

import PropTypes from 'prop-types';

import { useContext as useUsersContext } from 'components/Users/Context';

import useMemberCycle from 'components/Common/VoluntaryBenefits/Hooks/useMemberCycle';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function Info({ cycle }) {
  const { state: stateUsers } = useUsersContext();

  const member = stateUsers.user.attributes.specific;

  const info = useMemberCycle({
    memberId: member.id,
    cycleId: cycle.id,
  });

  if (info === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  return (
    <div className="row">
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small text-gray-700 fw-light">Start and End Date</div>
        <div className="fw-semibold">
          {info.attributes.form_format_cycle_start}
          {' '}
          -
          {' '}
          {info.attributes.form_format_cycle_end}
        </div>
      </div>
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small text-gray-700 fw-light">Effective Date</div>
        <div className="fw-semibold">{info.attributes.format_effective_date}</div>
      </div>
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small text-gray-700 fw-light">Program Selected</div>
        <div className="fw-semibold">
          {info.attributes.current_product}
          -session program
        </div>
      </div>
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small text-gray-700 fw-light">Program Cost</div>
        <div className="fw-semibold">{info.attributes.format_employee_total_cost}</div>
      </div>
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small text-gray-700 fw-light">Payroll Periods</div>
        <div className="fw-semibold">{info.attributes.pay_frequency}</div>
      </div>
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small text-gray-700 fw-light">Payroll Deduction</div>
        <div className="fw-semibold">{info.attributes.format_employee_pay_period}</div>
      </div>
      <div className="col-xl-3 col-lg-4 col-md-4 col-6 mt-3">
        <div className="mb-1 small fw-ligh text-primary">Paid</div>
        <div className="fw-semibold">{info.attributes.total_paid}</div>
      </div>
    </div>
  );
}

Info.propTypes = {
  cycle: PropTypes.object.isRequired,
};
